import React, { useContext, useCallback, FC } from "react";
import { ModalContext } from "@/context/ModalContext";
import RightArrow from "@/SvgIcons/RightArrow";
import { IModalActions, ModalTypes } from "@/types/modal";
import styles from "./mobile-menu.module.scss";
import ClientSideButton from "@/components/molecules/Carousels/HeroCarousel/ClientSideButton";
import popupData from "@/data/popup-data.json";
import headerMenuData from "@/data/header-menu-data.json";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";
import { GA_EVENTS, GAEvent } from "@/helpers/gaEvents";
interface MenuCTAProps {
  isSponsoredCertificates: boolean;
}

const MenuCTA: FC<MenuCTAProps> = ({ isSponsoredCertificates }) => {
  const { modalDispatch } = useContext(ModalContext);
  const { LEAD_INITIATE } = GAEvent;

  const studentLoginHandler = useCallback(() => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.LoginModal,
      },
    });

    setTimeout(() => {
      pushToDataLayer({
        event: "student_login_initiate",
        cta_text: "STUDENT LOGIN",
        page_type: getGlobalStateValue("pageType"),
        page_url: location.href,
      });
    }, 2500);
  }, [modalDispatch]);

  return (
    <div className={styles.studentCTA}>
      <button onClick={studentLoginHandler} className={styles.studentLogin}>
        Existing Student Login <RightArrow stroke="#1a325d" />
      </button>

      <ClientSideButton
        modalType={
          isSponsoredCertificates
            ? ModalTypes.ConnectModalFormSponsoredCourses
            : ModalTypes.ConnectModal
        }
        GADataNew={{
          ...GA_EVENTS.get(LEAD_INITIATE),
          cta_text: "Apply Now",
          section_name: "Header",
          header_title: "NA",
          isPageType: true,
          page_url: true,
        }}
        webEngageEvents={{
          "Section Name": "Header",
          isPageType: true,
        }}
        modalData={{
          associatedPrograms: headerMenuData["associatedPrograms"],
          isLandingPage: true,
          popup: popupData,
        }}
        ctaText={isSponsoredCertificates ? "ENROLL NOW" : "APPLY NOW"}
        className={styles.mobileApplyNowBtn}
      />
    </div>
  );
};

export default MenuCTA;
